// src/pages/PrivacyPolicy/PrivacyPolicy.js
import React, { useEffect, useState } from "react";
import { fetchPrivacyPolicy } from "../../services/api";
import { FaLock } from "react-icons/fa";
import SubHeader from "../../components/Header/SubmenuHeader";

const PrivacyPolicy = () => {
  const [open, setOpen] = useState(true); // Default open
  const [privacy, setPrivacy] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getData = async () => {
      try {
        const result = await fetchPrivacyPolicy();
        setPrivacy(result);
      } catch (err) {
        console.error("Error fetching Privacy Policy:", err);
      } finally {
        setLoading(false);
      }
    };
    getData();
  }, []);

  if (loading) {
    return <p className="text-center mt-10 text-lg font-medium">Loading...</p>;
  }

  return (
    <div className="w-full min-h-screen flex flex-col items-center bg-[#FDFEFF]">
      {/* Header */}
      <SubHeader title="Privacy Policy" />

      {/* Content */}
      <main className="w-full max-w-[701px] mt-[63px] px-4">
        <div className="border rounded-lg shadow">
          <button
            onClick={() => setOpen(!open)}
            className="w-full text-left px-4 py-3 bg-[#f7f9fc] text-[#004990] flex items-center justify-between rounded-t-lg focus:outline-none"
          >
            <span
              className="flex items-center gap-2 font-[400] text-[22px] leading-[100%]"
              style={{ fontFamily: "Alata" }}
            >
              <FaLock className="text-[#004990]" />
              Privacy Policy
            </span>
            <svg
              className={`w-5 h-5 text-[#004990] transform transition-transform duration-300 ${
                open ? "rotate-90" : "rotate-0"
              }`}
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 5l7 7-7 7"
              />
            </svg>
          </button>

          {open && privacy && (
            <div
              className="px-4 py-4 bg-white text-gray-700 rounded-b-lg"
              style={{ fontFamily: "Dongle" }}
            >
              <p className="text-[30px] text-gray-500 mt-4 leading-[32px]">
                Effective Date: {privacy.effective_date || "N/A"}
              </p>
              <div
                className="text-[30px] leading-[32px] whitespace-pre-line"
                dangerouslySetInnerHTML={{
                  __html:
                    privacy.formatted_content ||
                    "<p>No Privacy Policy available.</p>",
                }}
              />
            </div>
          )}
        </div>
      </main>
    </div>
  );
};

export default PrivacyPolicy;
